import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, Tooltip, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';


export default class PendingInterventions extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            interventions_array: [],
            intervention_templates_array: [],
            assign_view: false,
            search_name: '',
            search_ready: false,
            searching: false,
            current_record: {},
            nominees_array: [],
            show_assignees: false,
            creating_nomination: false,
            selected_template: null,
            deadline: null,
            editing: false,
            bulk_assign: false,
            refresh_required: false,
        }

        this.state = {
            error: false,
            error_message: '',
            querying: true,
            interventions_array: [],
            intervention_templates_array: [],
            assign_view: false,
            search_name: '',
            search_ready: false,
            searching: false,
            current_record: {},
            nominees_array: [],
            show_assignees: false,
            creating_nomination: false,
            selected_template: null,
            deadline: null,
            editing: false,
            bulk_assign: false,
            refresh_required: false,
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        };

        this.datasheetFieldSpecs = [
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'employee_number', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'employee', headerName: 'Employee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'intervention', headerName: 'Learning Intervention', width: 250},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'created', headerName: 'Assigned', width: 120},
            { field: 'assignor', headerName: 'Assigned By', width: 160},
            { field: 'deadline_date', headerName: 'Deadline', width: 120},
        ]

        this.datasheetFieldSpecs2 = [
            { field: 'nominate', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.createNom(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Assign
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},

            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'employee_number', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_all_assigned_interventions',this.props.gwt)
        .then(reply=>{
            // console.log('query_all_assigned_interventions :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_all_assigned_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_all_assigned_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    let created = null;
                    for (var i=0;i<record_array.length;i++){
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        if (record_array[i].deadline_date){
                            deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                            record_array[i].deadline_date = deadline_date;
                        }
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, interventions_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, interventions_array:reply.Records?reply.Records : [], filtered_assessments_array:reply.Records?reply.Records : []});
                }

            }
        });

    };
    
    resetMe = () => {
        console.log('called resetme...');
        if (this.state.editing){
            this.setState({search_name:'',searching:false,error:false,error_message:'',search_ready:false,show_assignees:false,creating_nomination:false, editing:false,assign_view:false});
        } else {
            this.setState({search_name:'',searching:false,error:false,error_message:'',search_ready:false,show_assignees:false,creating_nomination:false, editing:false});
        }
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Pending Interv. ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Pending Learning Interventions as at ' + dateStr + '.xlsx');
        }
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.interventions_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.interventions_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.interventions_array){
                        if (record.employee.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.interventions_array){
                        if (record.employee_number.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.interventions_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   

    render() {return(
        <Grid
            container
            direction='column'
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1320
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={4}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={4}>
                        <Typography
                            style={{padding:10}}
                        >
                            Pending Learning Interventions
                        </Typography>
                    </Grid>

                    <Grid item xs={4}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            // style={{backgroundColor:'yellow'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.interventions_array.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                // show_branch_filter={true}
                                // show_cycle_filter={true}
                            />
                        </Grid>
                    </Grid>

                </Grid>

                <DatasheetView 
                    dataset={this.state.filtered_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    height={500}
                />

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1320,maxWidth:1320, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}